import React from 'react'

const VideoCall = (props) => {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" width="29" height="21" viewBox="0 0 29 21">
          <g transform="translate(1.726 1.601)" stroke="#000" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
              <rect width="18.083" height="18.083" rx="3" />
              <path d="m18.083 6.458 5.877-2.945a1.292 1.292 0 0 1 1.873 1.163v8.731a1.292 1.292 0 0 1-1.873 1.163l-5.877-2.945" />
          </g>
      </svg>
    )
}

export default VideoCall

